import { Outlet } from "react-router-dom";
import { useUserStore } from "entities/user";
import { USER_ROLES } from "shared/config/routes";
import { ClientEvents } from "./client-events/ClientEvents";

export const LkEventsPage = () => {
  const { role } = useUserStore();

  if (role === USER_ROLES.CLIENT) {
    return <ClientEvents />;
  }

  if (role === USER_ROLES.MANAGER) {
    return <Outlet />;
  }

  return null;
};
